import * as z from "zod";

/**
 * Points Contextual at this team's Google Ads account so tracked events are
 * uploaded as conversions.
 *
 * One call rather than three because the steps are useless apart: credentials
 * with no conversion actions deliver nothing, and conversion actions with no
 * credentials cannot be created. Re-running is safe — existing conversion
 * actions are reused rather than duplicated.
 */
export const connectGoogleAdsToContextual = {
  name: "connectGoogleAdsToContextual" as const,
  input: z.object({
    /**
     * Events to upload as conversions. Contextual resolves a conversion action
     * for each, creating any the Google Ads account does not already have.
     */
    eventNames: z.array(z.string()),
  }),
  output: z.object({
    integrationId: z.string(),
    customerId: z.string(),
    /** Event name to the Google Ads conversion action it will upload against. */
    conversionActionIds: z.record(z.string(), z.string()),
  }),
};
